"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classNames = _interopRequireDefault(require("@ux/component-utilities/lib/classNames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const UX_BUTTON_SET_CLASSNAME = 'ux-button-set';
/**
 * UXCore based ButtonSet.
 *
 * @displayName Button Set
 * @class ButtonSet
 * @public
 */

class ButtonSet extends _react.Component {
  constructor() {
    super();
  }
  /**
   * Render the ButtonSet Component.
   *
   * @returns {ReactElement} ButtonSet element.
   * @private
   */


  render() {
    const {
      className,
      split,
      children
    } = this.props;
    const hostClassNames = (0, _classNames.default)(UX_BUTTON_SET_CLASSNAME, className);
    const marginClassNames = (0, _classNames.default)(`${UX_BUTTON_SET_CLASSNAME}-margin`, {
      [`${UX_BUTTON_SET_CLASSNAME}-split`]: split
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: hostClassNames
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: marginClassNames,
      role: "group"
    }, children));
  }

}
/**
 * Optional properties: split defines if the ButtonSet's
 * children should split to multiple lines or not.
 *
 * @enum {Object} expected types of properties.
 * @public
 */


exports.default = ButtonSet;
ButtonSet.propTypes = {
  /** Classes to set on the element */
  className: _propTypes.default.string,

  /** Defines whether child elements too wide to fit on screen should drop down to the next line*/
  split: _propTypes.default.bool,

  /** Child elements to be included in the Button Set*/
  children: _propTypes.default.node
};